import { Resources } from 'constants/resources';

import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Preset } from 'types/embedded/preset';

type Props = {
  record?: Preset;
  onSuccess: () => void;
} & Pick<DeleteDialogProps, 'open' | 'onClose'>;

export const PresetsDeleteDialog: React.FC<Props> = ({ onSuccess, ...props }) => {
  const notify = useNotify();
  const { record } = props;

  const handleSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.Presets] });
    notify('Пресеты успешно удалены', { type: 'info' });
    onSuccess();
  };

  return (
    <DeleteDialog
      {...props}
      details={
        <>
          Пресеты в валюте <TypographyBold fontSize={16} text={record?.currency?.alphaCode ?? ''} />{' '}
          для мерчанта <TypographyBold fontSize={16} text={record?.merchant?.name ?? ''} /> и шлюза{' '}
          <TypographyBold fontSize={16} text={record?.gateway?.name ?? ''} /> будут удалены без
          возможности восстановления.
        </>
      }
      onSuccess={handleSuccess}
      title="Удаление пресетов"
    />
  );
};
